import React, { useState, useEffect } from 'react';
import { Bell, X } from 'lucide-react';
import { Button } from './ui/button';

export default function NotificationPermissionBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if notifications are supported and permission is needed
    if ('Notification' in window && Notification.permission === 'default') {
      setShowBanner(true);
    }
  }, []);

  const requestPermission = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        setShowBanner(false);
        // Show a test notification
        new Notification('Notifications Enabled!', {
          body: 'You will now receive real-time notifications',
          icon: '/logo192.png',
        });
      }
    } catch (error) {
      console.error('Error requesting notification permission:', error);
    }
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-blue-600 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Bell className="h-5 w-5" />
          <span className="text-sm font-medium">
            Enable notifications to receive real-time updates about tickets and activities
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Button
            onClick={requestPermission}
            variant="secondary"
            size="sm"
            className="bg-white text-blue-600 hover:bg-gray-100"
          >
            Enable
          </Button>
          <button
            onClick={() => setShowBanner(false)}
            className="p-1 hover:bg-blue-700 rounded"
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
